import axios, { type AxiosResponse } from 'axios'
import type { Announcement } from '@/types'

export const getAnnouncement = async () => {
  return axios.get<AxiosResponse<Announcement[]>>('belajar-id/admin/v1/cms-client/announcement')
}
